/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meca_Trig_Cur_ThresholdInputs */



/**
* | output |
* | --- |
* | "Motor threshold" |
*
* @param {Meca_Trig_Cur_ThresholdInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const meca_trig_cur_threshold = /** @type {((inputs?: Meca_Trig_Cur_ThresholdInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meca_Trig_Cur_ThresholdInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Motor threshold")
	return /** @type {LocalizedString} */ ("Seuil moteur")
});